module.exports = __webpack_public_path__ + "static/dc-d47cf7b36860947fd3ef1ec995ce2a83.jpg";